<template>
  <LmDialog v-model="createModal" :styles="{ minWidth: '900px' }" title="Create License Qualifier Label">
    <template #toolbar-actions>
      <q-btn :loading="loading" color="tertiary" size="sm" class="q-mr-sm" @click="onSave">
        Save
      </q-btn>
    </template>

    <template #content>
      <q-card-section :style="{ maxHeight: '500px', height: '400px' }" class="scroll">
        <div class="row q-col-gutter-md">
          <div class="col self-end">
            <q-input id="name" v-model="label.name" required label="New qualifier label name" type="text" outlined />
          </div>

          <div class="col self-end">
            <enhanced-q-select id="term_label" v-model="label.term_label" :options="termLabelOptions" label="Term" />
          </div>
        </div>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import EnhancedQSelect from '@components/general/EnhancedQSelect'

export default {
  components: {
    LmDialog,
    EnhancedQSelect
  },

  props: {
    value: Boolean,

    options: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    loading: false,
    label: {
      name: null,
      term_label: null
    }
  }),

  computed: {
    createModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    termLabelOptions() {
      if (!this.options) return []
      return this.generateOptions({ collection: this.options })
    }
  },

  methods: {
    onSave() {
      this.loading = true
      apiTo
        .CREATE_QUALIFIER_LABEL(this.label)
        .then(({ data }) => {
          this.$emit('new-label', data.result)
          this.createModal = false
          this.label.name = null
          this.label.term_label = null
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
